import script from "./FloatMenuItems.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatMenuItems.vue?vue&type=script&setup=true&lang=js"

import "./FloatMenuItems.vue?vue&type=style&index=0&id=b7feffda&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7feffda"]])

export default __exports__